import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.INIT = function (state, payload) {
  state.rows = payload
}
mutations.DO_REMOVE = function (state, payload) {
  let rows = state.rows.filter(x => x.id !== payload.id)
  state.rows = rows
  localStorage.setItem('fs_cart', JSON.stringify(rows))
  SysUtils.showSuccess('Item removed from cart!')
}
mutations.SAVE_PAYMENT = function (state, payload) {
  localStorage.removeItem('fs_cart')
  state.rows = []
}
mutations.COUNTRY_LIST = function (state, payload) {
  state.country_list = payload
}
mutations.PHONE_LIST = function (state, payload) {
  state.phone_list = payload
}
mutations.FIND_DETAIL = function (state, payload) {
  state.purchase_row = payload.row
  state.purchase_detail = payload.detail
}
mutations.CLEAR_ALL = function (state, payload) {
  state.purchase_row = {}
  state.purchase_detail = []
}

const state = {
  rows: [],
  row: {},
  condition: {},
  country_list: null,
  phone_list: null,
  purchase_row: {},
  purchase_detail: []
}
const actions = {
  init: ({ commit, state }) => {
    let cart = JSON.parse(localStorage.getItem('fs_cart'))
    if (!SysUtils.isEmpty(cart)) commit('INIT', cart)
    const ctx = {
      data: {
        getCountryListSelectBox: { api: 'C0001CountryService.getCountryListSelectBox' },
        getPhoneListSelectBox: { api: 'C0001CountryService.getPhoneListSelectBox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('COUNTRY_LIST', data.getCountryListSelectBox.output)
        commit('PHONE_LIST', data.getPhoneListSelectBox.output)
      })
  },
  doRemove: ({ commit, state }, row) => {
    commit('DO_REMOVE', row)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  doSearchDetail: ({ commit, state }, condition) => {
    return client.postData({ data: { doSearchDetail: { api: 'P0201PurchaseService.doSearchDetail', input: condition } }
    })
      .then((data) => {
        if (!SysUtils.isEmpty(data.doSearchDetail.output.row) || !SysUtils.isEmpty(data.doSearchDetail.output.detail)) commit('FIND_DETAIL', data.doSearchDetail.output)
        else SysUtils.showError('Session expired!')
      })
  },
  doSavePayment: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { doSavePayment: { api: 'P0201PurchaseService.doSave', input: condition } } })
      .then((data) => {
        SysUtils.showSuccess('Payment successful!')
        commit('SAVE_PAYMENT')
      })
  },
  doUpdateStatus: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { doUpdateStatus: { api: 'P0201PurchaseService.saveData', input: condition } } })
      .then((data) => {
        SysUtils.showSuccess('Status Updated! Please come again!')
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
